export default __webpack_public_path__ + "static/media/auth-signup.ac49a231.png";